<template>
    <div>
        <div class="text-right">
            <el-button type="primary" size="mini" @click="setVisible(true)">
                Create Article
            </el-button>
        </div>
        <el-dialog title="Create Article" :visible.sync="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Article title" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="Description" prop="desc">
                    <el-input v-model="form.desc" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                title: '',
            },
            rules: {
                'title': [
                    { required: true, message: 'Enter the title of the article.', trigger: 'blur' },
                ],
                'desc': [
                    { required: true, message: 'Enter the product description.', trigger: 'blur' },
                    { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
                ],
            }
        }
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/articles`, {
                        desc: this.form.desc,
                        title: this.form.title,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.$router.push({ name: 'articles-id', params: { id: data.article.id } })
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.setVisible(false)
            this.$refs[form].resetFields()
        },

        setVisible(status) {
            this.dialogVisible = status
        },
    },
}
</script>
